// extracted by mini-css-extract-plugin
export default {"allActivitiesSection":"Activities_allActivitiesSection__v+WGk","total":"Activities_total__VJPWN"};